<template lang="pug">
  div
    .parallax.mt-6
      v-row(align="center" style="height:100%")
        v-col(cols="12" align="center")
          .display-2.justify-center Member Services
    v-container()
      v-row(justify="center")
        v-col(cols="12")
          v-img.float-md-left.mr-4.mb-4.elevation-6( src="../../assets/img/4255632_orig.png" width="50%" "min-width"="300" ) 
          .body-1Member Services, formerly known as the New Members Team, is a new City of Refuge UCC ministry called to serve the entire congregation. Like many other ministries, our goal is to keep us connected, and provide support for the City of Refuge UCC family.
          .title Vision Statement
          .body-1Our members will be empowered to be spiritually, mentally, physically and materially responsible for their personal lives and will be able to go into the world and carry this knowledge to others in need.
          br
          .title Current Projects
          ul(style="display:table")
            li Welcoming New Members who are called to join 
              span.text-no-wrap City of Refuge UCC
            li Providing support for the Christian Education Classes
            li Ministering to new members
            li Developing a City of Refuge UCC Resource Guide
            li Coordinating Family Talk, formally known as Body Life
              ul
                li Representatives from all departments/ministries meet to share information
            li Creating a City of Refuge UCC Family and Business Directory
            li Organizing the City of Refuge UCC Family Fun Day/Night
          .body-1 We love God, we love the people of God, and we are here to support. We are seeking new team members -- come join us!
          .title Contact Us
          .body-1 For More Information, please contact Member Services by reaching:
          .body-1 Leaders:
            br
            a.pl-6(href="") Pastor Janice Sommervile
            br
            a.pl-6(href="") Lay Pastor James Pearman
            br
            a.pl-6(href="") Minister Terry Wells
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.parallax
  background-image url('../../assets/img/background/Treelinedroad.jpg')
  height 300px
  background-attachment fixed
  background-position top
  background-repeat no-repeat
  background-size 100% 90%
  color white

@media screen and (max-width: 950px)
  .parallax
    background-attachment scroll
</style>
